module.exports = {};



//////////////////
// WEBPACK FOOTER
// /Users/juan.carvajal/Documents/clubmin2/node_modules/core-js/modules/_iterators.js
// module id = ../../../../core-js/modules/_iterators.js
// module chunks = polyfills